import BlueGeometricThumbnailPath from '../../../assets/template-thumbnails/geometric/blue-geometric-template-thumbnail.png';

const BlueGeometricTemplate = {
    id: 'blue-geometric-template',
    name: 'Blue',
    category: 'Geometric',
    settings: {
      layoutId: 'centered-header',
      designId: 'custom',
      style: 'tech',
      background: 'geometric',
      barStyleId: 'squares',
      specialEffectId: 'timeline',
      customColors: {
        primary: "#1877F2",
        secondary: "#0668E1",
        tertiary: "#0668e1",
        quaternary: "#3578E5",
        accent1: "#00B2FF",
        accent2: "#0081FB",
        accent3: "#1195F5",
        accent4: "#0064E0",
        accent5: "#0099FF",
        accent6: "#0077E6",
        accent7: "#0088FA",
        accent8: "#2D88FF",
        text: "#050505",
        textSecondary: "#65676B",
        sidebarText: "#050505",
        sidebarPrimary: "#1877F2",
        background: "#ffffff",
        sidebarBackground: "#F0F2F5",
        border: "#CED0D4"
      },
      typography: {
        cvTitle: { fontSize: 40, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        sectionTitle: { fontSize: 11, lineHeight: 1.3, fontFamily: "'Roboto', sans-serif" },
        body: { fontSize: 9.5, lineHeight: 1, fontFamily: "'Roboto', sans-serif" },
        smallText: { fontSize: 8, lineHeight: 1.5, fontFamily: "'Roboto', sans-serif" },
      },
    },
    thumbnail: BlueGeometricThumbnailPath
  };

export default BlueGeometricTemplate; 